import { default as Tab } from './Tab';

export default Tab;
